import { addHdmiSourceChangeListener,removeHdmiSourceChangeListner, getHdmiCastingDevices } from "utils/hdmi/hdmiSettingsData";

class CastingManager {
    devices = [];
    initialized=false
    listeners = new Set();

    async initialize() {
        if(this.initialized) return
        this.devices = await getHdmiCastingDevices();
        addHdmiSourceChangeListener(this.refresh.bind(this));
        console.log('[INFO]',"---HDMI LISTENER ADDED---")
        this.initialized=true
    }
  
    async refresh() {
        this.devices = await getHdmiCastingDevices();
        this.notify();
    }

    notify() {
        this.listeners.forEach(listener => listener(this.devices));
    }

    
    async removeHdmiListener(){
       if(this.initialized){
        console.log('[INFO]',"---HDMI LISTENER REMOVED---")
        await removeHdmiSourceChangeListner()
        this.initialized=false
       }
    }

    subscribe(listener) {
        this.listeners.add(listener);
        listener(this.devices);
        return {unsubscribe:() => this.listeners.delete(listener)};
    }

    getDevices() {
        return this.devices;
    }
}

export default new CastingManager();